module.exports = __webpack_public_path__ + "media/packs/landing_page/images/activities/gym-74ca979f40f3bfd2db61a8b4cec6c66d.png";